/**
 * Exercise Hub — clinical movement prescription module.
 * Contains 3 fitness levels + 6 clinical constraints + zone calculator.
 * Shared by ExerciseHub.jsx and PrintExercisePlan.jsx.
 */

export const FITNESS_LEVELS = [
  { id: "beginner",     name_en: "Beginner",     name_mr: "सुरुवात करणारा", desc_en: "Starting after a long gap or for the first time.",       desc_mr: "दीर्घ काळानंतर किंवा पहिल्यांदाच सुरुवात करत आहे." },
  { id: "intermediate", name_en: "Regular",      name_mr: "नियमित",         desc_en: "I exercise 2-3 times a week consistently.",                desc_mr: "मी आठवड्यातून २-३ वेळा सातत्याने व्यायाम करतो." },
  { id: "advanced",     name_en: "Active",       name_mr: "सक्रिय",         desc_en: "I am highly active and looking for optimisation.",        desc_mr: "मी अत्यंत सक्रिय आहे आणि अधिक सुधारणा शोधत आहे." },
  { id: "muscle-strength", name_en: "Muscle Strengthening", name_mr: "स्नायू बळकटीकरण", desc_en: "Resistance training to preserve lean mass — ideal for Diabesity / GLP-1 patients.", desc_mr: "स्नायू टिकवण्यासाठी बल-प्रशिक्षण — डायबेसिटी / GLP-1 रुग्णांसाठी विशेष." },
];

export const CLINICAL_CONSTRAINTS = [
  { id: "knee",   name_en: "Knee Pain",         name_mr: "गुडघे दुखी",           icon: "🦵" },
  { id: "back",   name_en: "Lower Back Pain",   name_mr: "कंबर दुखी",           icon: "🧘" },
  { id: "heart",  name_en: "Heart History",     name_mr: "हृदयविकार इतिहास",     icon: "🫀" },
  { id: "breath", name_en: "Breathlessness",    name_mr: "दम लागणे",             icon: "🫁" },
  { id: "vision", name_en: "Retinopathy",       name_mr: "रेटिनोपॅथी (डोळे)",   icon: "👁️" },
  { id: "foot",   name_en: "Active Foot Ulcer", name_mr: "पायाची जखम",          icon: "🦶" },
];

/** BMI + age-aware exercise zone recommendation. */
export function computeExerciseZone({ age, weight_kg, height_cm }) {
  const w = parseFloat(weight_kg);
  const h = parseFloat(height_cm);
  const a = parseFloat(age);
  if (!Number.isFinite(w) || !Number.isFinite(h) || !Number.isFinite(a)) return null;
  const bmi = +(w / ((h / 100) ** 2)).toFixed(1);
  let zone_en = "Moderate";
  let zone_mr = "मध्यम";
  if (bmi > 30) { zone_en = "Low Impact / High Frequency"; zone_mr = "कमी दाब / जास्त वारंवारता"; }
  if (a > 60) { zone_en = "Balance & Flexibility Focus"; zone_mr = "समतोल आणि लवचिकता"; }
  return { bmi, zone_en, zone_mr };
}
